import React from 'react'

import OrdersPage from '../OrdersPage'

const OrderVisit = props => {
  return <OrdersPage props={{ ...props }} />
}
export default OrderVisit
